import api from "./axios";

export const getTopics = async () => {
  return await api.get("/api/web-api/integration/otrs/get-topics");
};
